import { CurrentUserDTO } from '../../services/server-types';
import { TeamDetailsState } from '../configure-store';
import { InviteData, TeamData, TeamMembersData, UserData } from '../../types/teamMembers';
import { Role, RolesArea, RolesData } from '../../types/roles';
import { AreasData } from '../../types/areas';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const NEW_INVITES_SENT_SUCCESS = 'NEW_INVITES_SENT_SUCCESS';
export const FETCH_TEAM_MEMBERS_SUCCESS = 'FETCH_TEAM_MEMBERS_SUCCESS';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const SET_ROLE_AREAS = 'SET_ROLE_AREAS';
export const SET_TEAM_DETAILS_START = 'SET_TEAM_DETAILS_START';
export const SET_TEAM_DETAILS_SUCCESS = 'SET_TEAM_DETAILS_SUCCESS';
export const REMOVE_CONTRIBUTOR_SUCCESS = 'REMOVE_CONTRIBUTOR_SUCCESS';
export const REMOVE_CONTRIBUTOR_FAILED = 'REMOVE_CONTRIBUTOR_FAILED';
export const REVOKE_INVITE_SUCCESS = 'REVOKE_INVITE_SUCCESS';
export const REVOKE_INVITE_FAILED = 'REVOKE_INVITE_FAILED';
export const RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS';
export const SET_USER_ROLE_SUCCESS = 'SET_USER_ROLE_SUCCESS';
export const SET_TEAM_ROLE_SUCCESS = 'SET_TEAM_ROLE_SUCCESS';
export const SET_INVITE_ROLE_SUCCESS = 'SET_INVITE_ROLE_SUCCESS';
export const SET_TEAM_MEMBER_ROLES_FAILED = 'SET_TEAM_MEMBER_ROLES_FAILED';
export const FETCH_USER_DETAILS_START = 'FETCH_USER_DETAILS_START';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const ROLE_FILTER_ADDED = 'ROLE_FILTER_ADDED';
export const ROLE_FILTER_REMOVED = 'ROLE_FILTER_REMOVED';
export const STATUS_FILTER_CHANGED = 'STATUS_FILTER_CHANGED';
export const QUERY_CHANGED = 'QUERY_CHANGED';
export const SORT_TOGGLED = 'SORT_TOGGLED';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const FETCH_AREAS_SUCCESS = 'FETCH_AREAS_SUCCESS';
export const SET_ROLE_SUCCESS = 'SET_ROLE_SUCCESS';
export const REMOVE_ROLE_SUCCESS = 'REMOVE_ROLE_SUCCESS';
export const SHOW_TEAM_AND_SITE_OWNER_HINT = 'SHOW_TEAM_AND_SITE_OWNER_HINT';
export const HIDE_TEAM_AND_SITE_OWNER_HINT = 'HIDE_TEAM_AND_SITE_OWNER_HINT';
export const CANCEL_TRANSFER_OWNERSHIP_SUCCESS = 'CANCEL_TRANSFER_OWNERSHIP_SUCCESS';
export const SET_CONTRIBUTOR_LIMIT = 'SET_CONTRIBUTOR_LIMIT';
export const SET_SHOULD_ENFORCE_CONTRIBUTORS = 'SET_SHOULD_ENFORCE_CONTRIBUTORS';
export const NAMES_AND_EMAILS_FILTER_CHANGED = 'NAMES_AND_EMAILS_FILTER_CHANGED';
export const SET_LOADING_TEAMMATES = 'SET_LOADING_TEAMMATES';

export interface FetchTeamMembersSuccessAction {
  type: 'FETCH_TEAM_MEMBERS_SUCCESS';
  roles: TeamMembersData;
}

export interface FetchRolesSuccessAction {
  type: 'FETCH_ROLES_SUCCESS';
  roles: RolesData;
}

export interface SetRoleAreasAction {
  type: 'SET_ROLE_AREAS';
  roleAreas: RolesArea[];
}

export interface NewInvitesSentSuccessAction {
  type: 'NEW_INVITES_SENT_SUCCESS';
  newInvites: InviteData[];
}

export interface RemoveContributorSuccessAction {
  type: 'REMOVE_CONTRIBUTOR_SUCCESS';
  removedContributorId: string;
}

export interface RemoveContributorFailedAction {
  type: 'REMOVE_CONTRIBUTOR_FAILED';
  user: UserData;
  team: TeamData;
}

export interface RevokeInviteSuccessAction {
  type: 'REVOKE_INVITE_SUCCESS';
  revokedInviteId: string;
}

export interface RevokeInviteFailedAction {
  type: 'REVOKE_INVITE_FAILED';
  invite: InviteData;
}

export interface SetTeamDetailsSuccessAction {
  type: 'SET_TEAM_DETAILS_SUCCESS';
  teamDetails: TeamDetailsState;
}

export interface SetTeamDetailsStartAction {
  type: 'SET_TEAM_DETAILS_START';
}

export interface SetInviteRoleSuccessAction {
  type: 'SET_INVITE_ROLE_SUCCESS';
  inviteId: string;
  roles: string[];
}

export interface SetUserRoleSuccessAction {
  type: 'SET_USER_ROLE_SUCCESS';
  userId: string;
  roles: string[];
}

export interface SetTeamRoleSuccessAction {
  type: 'SET_TEAM_ROLE_SUCCESS';
  accountId: string;
  roles: string[];
}

export interface SetTeamMemberRolesFailedAction {
  type: 'SET_TEAM_MEMBER_ROLES_FAILED';
  teamMemberId: string;
  roles: string[];
}

export interface FetchUserDetailsStartAction {
  type: 'FETCH_USER_DETAILS_START';
}

export interface FetchUserDetailsSuccessAction {
  type: 'FETCH_USER_DETAILS_SUCCESS';
  userDetails: CurrentUserDTO;
}

export interface ResendInviteSuccessAction {
  type: 'RESEND_INVITE_SUCCESS';
  updatedInviteData: InviteData;
}

export interface FetchAreasSuccessAction {
  type: 'FETCH_AREAS_SUCCESS';
  areas: AreasData;
}

export interface SetRoleSuccessAction {
  type: 'SET_ROLE_SUCCESS';
  role: Role;
}

export interface RemoveRoleSuccessAction {
  type: 'REMOVE_ROLE_SUCCESS';
  roleId: string;
}

export interface CancelTransferOwnershipSuccessAction {
  type: 'CANCEL_TRANSFER_OWNERSHIP_SUCCESS';
}

export interface SetContributorLimitActionAction {
  type: 'SET_CONTRIBUTOR_LIMIT';
  contributorLimit: number;
}

export interface SetShouldEnforceContributorsAction {
  type: 'SET_SHOULD_ENFORCE_CONTRIBUTORS';
  shouldEnforceContributors: boolean;
}

export interface SetLoadingTeammatesAction {
  type: 'SET_LOADING_TEAMMATES';
  loadingTeammates: boolean;
}
